
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getUserAndRedirect } from '../../helpers/Functions';
import { ONBORADING_SCREEN, SIGNUP_MENU } from '../../navigation/Constants';
import LoginForm from './components/loginForm';
import { useHistory } from 'react-router';
import FacebookLogin from './components/FacebookLogin';
import AppleLogin from './components/AppleLogin';
import GoogleLogin from './components/GoogleLogin';
import { setProfileMemberData } from '../../redux/profileMember';
import { useDispatch } from 'react-redux';

const Login = () => {
   // const history = useHistory();
   // useEffect(() => {
   //     getUserAndRedirect(history);
   // }, [])
   const dispatch = useDispatch();
   useEffect(() => {
      dispatch(setProfileMemberData({ showNoProfilePictureModal: true }));
   }, [])

   return (
      <>
         <div className="content_sec wf-section">
            <div className="login_top">
               <Link to={ONBORADING_SCREEN} className="top_back login w-inline-block" >
                  <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
               </Link>
               <div className="login_logo" style={{ width: "200px" }}>
                  <img src="assets/images/shoshke_logo.svg" loading="lazy" alt="" />
               </div>
               <div>
                  <h2>טוב לראות אותך כאן!</h2>
                  זה המקום למלא מייל וסיסמה, ולהיכנס
               </div>
            </div>
            <div className="login_sec w-form">
               <LoginForm />
            </div>
            {/* <div className="login_social">
               <div>כניסה גם דרך חשבון גוגל או פייסבוק</div>
               <div className="form_buttons_group"> */}
            {/* <AppleLogin /> */}
            {/* <GoogleLogin isChecked={true} />
                  <FacebookLogin isChecked={true} />
               </div> */}
            {/* <div className="login_terms_use">
                  <div className="terms_txt title">אל דאגה</div>
                  <div className="terms_txt">, הרשמתך לא תפורסם בפייסבוק</div>
               </div>
               <div className="login_terms_use">
                  <div className="terms_txt">הרשמתך מהווה הסכמה ל</div>
                  <a href="#" className="terms_txt link">
                     תנאי השימוש והפרטיות
                  </a>
               </div> */}
            {/* </div> */}
            <div style={{ textAlign: "center" }}>

               עוד לא נרשמת?<br />
               <Link to={SIGNUP_MENU} style={{ textDecoration: 'underline' }}>להצטרפות לשושק'ה</Link>

            </div>
         </div>

      </>
   )

}

export default Login;


